import React from 'react';
import classes from './WelcomeText.module.scss'
import {Typography} from "@material-ui/core";

const WelcomeText = () => (
        <div className={classes.WelcomeText}>
            <Typography variant="h3">
                Tedious tasks can become fun!
            </Typography>
            <Typography variant="h5">
                Choose a proven motivational system that can turn boring but important activities into endless fun.
            </Typography>
            <Typography variant="h5">
                Help yourself and your child to achieve the set goals.
            </Typography>
        </div>
    )
;

export default WelcomeText;
